import React, { useState } from 'react'

// components
import { useViewport } from 'utils'
import ProgressingModal from 'components/Modal/ProgressingModal'

// styles
import styles from './index.module.scss'

import MerchApparelSection from './MerchApparelSection'
import MerchWallArtSection from './MerchWallArtSection'
import ApparelSection from './MerchApparelSection/ApparelSection'
import WallSection from './MerchWallArtSection/WallSection'

const MerchSection = props => {
  const { data, openNftPage } = props
  const viewport = useViewport()

  const [openApparelDetail, setOpenApparelDetail] = useState(data?.category === 'apparel')
  const [openWallArtDetail, setOpenWallArtDetail] = useState(data?.category === 'print')

  const [finishEditing, setFinishEditing] = useState(false)
  const [showApparelMode, setShowApparelMode] = useState(data?.category === 'apparel')
  const [showWallArtMode, setShowWallArtMode] = useState(data?.category === 'print')

  const [openProgressingModal, setOpenProgressingModal] = useState(false)
  const [apparel, setApparel] = useState(null)
  const [wallArt, setWallArt] = useState(null)

  return (
    <div className={styles.container}>
      <div className="w-full h-full flex justify-around">
        {showApparelMode ? (
          <div className="w-full lg:w-[58%] lg:flex hidden justify-center items-start pt-[50px]">
            <ApparelSection
              canvasId="canvas"
              nftName={data?.nftName}
              apparel={apparel}
              nftCoverUrl={data?.nftCoverUrl}
              finishEditing={finishEditing}
            />
          </div>
        ) : showWallArtMode ? (
          <div className="w-full lg:w-[58%] lg:flex hidden justify-center items-start pt-[50px]">
            <WallSection canvasId="wallart" nftName={data?.nftName} wallArt={wallArt} finishEditing={finishEditing} />
          </div>
        ) : (
          <></>
        )}

        <div
          className={`w-full lg:w-[42%] z-10 ${
            viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? 'g-container' : 'pt-[20px] g-right-container'
          } ${styles.rightBG}`}
        >
          {openApparelDetail ? (
            <MerchApparelSection
              nftName={data?.nftName}
              nftCoverUrl={data?.nftCoverUrl}
              mintAddress={data?.mintAddress}
              open={openApparelDetail}
              subCategory={data?.subCategory}
              base={data?.base}
              onBack={() => {
                openNftPage()
              }}
              setFinishEditing={editing => setFinishEditing(editing)}
              setApparel={apparel => setApparel(apparel)}
              setShowApparelMode={mode => setShowApparelMode(mode)}
            />
          ) : openWallArtDetail ? (
            <MerchWallArtSection
              nftName={data?.nftName}
              nftImage={data?.nftCoverUrl}
              nftCoverUrl={data?.nftCoverUrl}
              mintAddress={data?.mintAddress}
              open={openWallArtDetail}
              subCategory={data?.subCategory}
              onBack={() => {
                openNftPage()
              }}
              setFinishEditing={editing => setFinishEditing(editing)}
              setWallArt={image => {
                setWallArt(image)
              }}
              setShowWallArtMode={mode => setShowWallArtMode(mode)}
            />
          ) : (
            <></>
          )}
        </div>
      </div>

      {openProgressingModal && <ProgressingModal open={openProgressingModal} />}
    </div>
  )
}

export default MerchSection
